import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Button from 'components/Button';
import InputDateCustom from 'components/InputDateCustom';
import Input from 'components/Input';
import SVG from 'components/SVG';

import DaysFilter from 'features/myStatistics/DaysFilter';

import arrowSVG from './img/arrow.svg';

import './FilterBlock.scss';

const b = block('filter-general-report');

const FilterBlock = ({ handlers, values }) => {
  const locale = useSelector(state => state.locale.locale);
  const role = useSelector(state => state.auth.role);

  const { state } = values;

  const [isOpen, setIsOpen] = useState(true);

  return (
    <form className={b({ isOpen })} onSubmit={handlers.handleFormSubmit} onClick={handlers.handleKeyDown}>
      <div className={b('header')}>
        {locale.filter}
        <SVG
          className={b('header-icon', { closed: !isOpen }).toString()}
          svgProps={{ svg: arrowSVG }}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>

      {isOpen && (
        <div className={b('wrapper')}>
          <div className={b('days')}>
            <DaysFilter activeDay={state.activeDay} setActiveDay={handlers.handleActiveDayChange} />
          </div>

          <div className={b('content')}>
            <div className={b('row')}>
              <div className={b('title')}>{locale.from}</div>
              <div className={b('input')}>
                <InputDateCustom
                  value={state.beginDate}
                  onChange={v => handlers.handleDateChange('beginDate', v)}
                  deleteWord=""
                />
              </div>
            </div>

            <div className={b('row')}>
              <div className={b('title')}>{locale.to}</div>
              <div className={b('input')}>
                <InputDateCustom
                  value={state.endDate}
                  onChange={v => handlers.handleDateChange('endDate', v)}
                  deleteWord=""
                />
              </div>
            </div>

            <div className={b('row')}>
              <div className={b('title')}>{locale.roles?.[role - 1]}</div>
              <div className={b('input')}>
                <Input
                  value={state.search}
                  onChange={e => handlers.handleValueChange('search', e.currentTarget.value)}
                  placeholder={locale.login2}
                />
              </div>
            </div>

            <div className={b('input')}>
              <Button size="low" text={locale.acceptFilter} type="submit" />
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

export default FilterBlock;
